import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import BeachChairWithSun from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/BeachChairWithSun';
import HandWithThreePlusSigns from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/HandWithThreePlusSigns';
import PaperWithDollarSignAndBarChart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperWithDollarSignAndBarChart';
import TwoPeopleTwoWordBubbles from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPeopleTwoWordBubbles';
// styles
import { ColStyled } from './styles';

export const ITEMS = [
  {
    icon: HandWithThreePlusSigns,
    cardId: 'brokerage-accounts-services',
    cardHeading: 'Brokerage services',
    cardText: (
      <>
        You&#39;ll have access to a range of investment vehicles to help build your ideal portfolio&#8212;no matter what goals you have or where you are in life. While you&#39;ll make the decisions to buy, hold or sell, we&#39;ll help you figure out your options and recommend the right investments to take you where you want to go.
      </>
    ),
    linkId: 'brokerage-accounts-services',
    linkUrl: '/investments/brokerage-accounts-services/',
    ariaLabel: 'Find out more about our brokerage services.',
  },
  {
    icon: TwoPeopleTwoWordBubbles,
    cardId: 'financial-advisory-programs',
    cardHeading: 'Investment advisory services',
    cardText: (
      <>
        When you&#39;re looking for hands&#45;on investment advice and ongoing portfolio oversight, we&#39;ll carefully select one of our Signature Advisory Programs (curated by our Wealth Management Investment Team) that best fits your investment goals and guide you every step of the way.
      </>
    ),
    linkId: 'financial-advisory-services',
    linkUrl: '/investments/investment-advisory-services/',
    ariaLabel: 'Find out more about our investment advisory services.',
  },
  {
    icon: PaperWithDollarSignAndBarChart,
    cardId: 'private-wealth-management',
    cardHeading: 'Private wealth management',
    cardText: 'The unique complexities that come with significant wealth require a higher level of skill and a deeper partnership that goes beyond your assets. Our comprehensive approach can give you the edge you and your family need to enjoy your wealth today, and for generations to come.',
    linkId: 'private-wealth-management',
    linkUrl: '/private-wealth-management/',
    ariaLabel: 'Find out more about private wealth management.',
  },
  {
    icon: BeachChairWithSun,
    cardId: 'fixed-annuity-vs-variable-annuity',
    cardHeading: 'Variable annuities',
    cardText: 'Variable annuities can help you worry less about having enough retirement income with the opportunity to help grow your money, tax deferred, over and above what you can save by maxing out your 401(k) or IRA contributions.',
    linkId: 'fixed-annuity-vs-variable-annuity',
    linkUrl: '/investments/fixed-annuity-vs-variable-annuity/',
    ariaLabel: 'Find out more about variable annuties.',
  },
];

export default () => (
  <SectionContainer
    id='investments-product-callout-grouping'
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          Four types of investment products <WidowBlock>and services</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      {(
        ITEMS.map((item) => (
          <ColStyled
            key={item.cardId}
            medium={6}
            large={5}>
            <ProductCard
              cardId={`product-callout-investments-${item.cardId}-card`}
              backgroundVariant='lightA'
              // content
              icon={item.icon}
              cardHeading={item.cardHeading}
              cardText={item.cardText}
              // link props
              linkId={`product-callout-investments-${item.linkId}-link`}
              linkText='Find out more'
              linkUrl={item.linkUrl}
              ariaLabel={item.ariaLabel}
            />
          </ColStyled>
        ),
        )
      )}
    </Row>
  </SectionContainer>
);
